import { GiTwoCoins } from "react-icons/gi";
import { GrUserAdmin } from "react-icons/gr";
import { RiUserVoiceFill } from "react-icons/ri";
import { RiShieldUserFill } from "react-icons/ri";
import { FaUsers } from "react-icons/fa6";
import CardHeader from "../atoms/CardHeader";
import Breadcrumb from "../molecules/Breadcrumb";
import AccesoDirecto from "../molecules/dashboard/AccesoDirecto";

const UsuariosTemplate = () => {
    const linksAdmin = [
        { label: "Administradores", path: "/admins", icon: GrUserAdmin },
        { label: "Lideres de contabilidad", path: "/leaders", icon: RiUserVoiceFill },
        { label: "Contadores", path: "/contadores", icon: GiTwoCoins },
        { label: "Usuarios RS", path: "/usuariosRS", icon: FaUsers },
        { label: "Defensa Fiscal", path: "/df_usuarios", icon: RiShieldUserFill },
    ];

    return (
        <div className="space-y-2">
            <CardHeader>
                <Breadcrumb
                    items={[
                        { label: "Inicio", to: "/dashboard" },
                        { label: "Usuarios internos", to: null },
                    ]}
                />
            </CardHeader>
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
                {linksAdmin?.map((link, index)=>
                    <AccesoDirecto href={link.path} label={link.label} icon={link?.icon} key={index} />
                )}
            </div>
        </div>
    );
};

export default UsuariosTemplate;